export const enErrors = {
	requiredFields: "Not all necessary fields are filled.",
	expectedNumber: "Number expected / enter 0 if not needed.",
	customColumnAlreadyExists: "Custom column already exists.",
	invalidEmail: "Invalid email",
	invalidPassword: "Invalid password",
	passwordGuidelinesNotMet: "Password guidelines not met",
	termsAcceptanceMissing: "Terms acceptance missing",
	invalidValue: "Invalid value",
	invalidData: "Invalid data",
	userNotConfirmed: "User not confirmed",
	passwordMismatch: "Passwords do not match",
	invalidToken: "Invalid token",
	emailAlreadyTaken: "Email already taken",
	wentWrong: "Something went wrong",
	unauthorized: "Unauthorized",
	invalidAuthCode: "Invalid auth code",
	nameMissing: "Name missing",
	wrongUrlShouldBeLinkedinProfile: "Wrong URL. Should be a LinkedIn profile URL",
	notEnoughCredits: "Not enough credits",
	leadDatabaseUnavailable:
		"The lead database did not answer this search, so no profiles can be shown. Please contact support.",
	linkedinSuggestionsUnavailable:
		"Suggestions could not be loaded right now. Please try again in a moment.",
	maxAmountExceeded: "Maximum amount exceeded",
	invalidLinkedinUrl: "Invalid LinkedIn URL",
	accountIsBlocked: "Demo account expired. Contact support@signalist.io.",
	invalidUrl: "Invalid URL",
	invalidLinkedinEventUrl: "URL must be a valid LinkedIn Event Search URL",
	columnNameNoUnderscore: "Column name cannot contain underscores",
	setPasswordLinkInvalid: "Invalid password setup link.",
	setPasswordLinkExpired: "This invitation link has expired.",
	setPasswordLinkUsed: "This invitation link has already been used.",
	resetPasswordLinkInvalid: "Invalid reset link.",
	resetPasswordLinkExpired: "This reset link has expired.",
	resetPasswordLinkUsed: "This reset link has already been used.",
	setPasswordLinkMissing:
		"This invitation link is incomplete: the token is missing. Copy the whole link from the email into your browser, or request a new one.",
	resetPasswordLinkMissing:
		"This reset link is incomplete: the token is missing. Copy the whole link from the email into your browser, or request a new one.",
	linkedinTestRequiresConnection:
		"A LinkedIn test message can only go to a 1st-degree connection of the selected sender. Pick a profile that sender is connected to.",
	linkedinProfileNotFound:
		"LinkedIn did not return a profile for that URL. Check the link, or try again in a moment.",
	linkedinSubscriptionRequired:
		"LinkedIn refused this message: the selected account needs a subscription (Premium or Sales Navigator) to message this person.",
	rowNoLongerPlaceholder:
		"Someone was selected for this lead in the meantime, so your pick was not saved. The lead now shows them.",
	campaignEndDatePassed:
		"This campaign's end date has already passed. Set a new end date in the campaign settings, then activate it.",
	knowledgeDbBuildNotRetryable:
		"This Knowledge Base build cannot be retried: the last run did not fail, or a Knowledge Base already exists.",
	linkedinNotConnected:
		"This person hasn't accepted the LinkedIn invitation yet, so a message can't be sent to them. Wait for the acceptance and try again.",
	linkedinRecipientUnreachable:
		"LinkedIn cannot deliver to this profile — it does not accept messages from the selected account.",
	linkedinAccountDisconnected:
		"The selected LinkedIn account is disconnected. Reconnect it under Personal settings → Connected Accounts and try again.",
	linkedinRateLimited: "LinkedIn's limit for this account has been reached. Try again later.",
	unipileRequestFailed: "The messaging provider could not complete the request. Try again later.",
	aiProviderFailed: "The AI service could not answer right now. Try again in a few minutes.",
	webhookUrlMasked:
		"This address still contains the hidden part (•••). Paste the full webhook address.",
	smartListPrivateList:
		"A smart list can only use lists your whole team can see. Remove the private list from the list filter: the daily run cannot read it.",
	webhookSecretAlreadyRevealed:
		'This secret was already shown once. Use "Rotate secret" to get a new one.',
	webhookTestEventTooSoon: "A test event was just sent. Wait a few seconds and try again.",
	webhookTestTargetPrivate:
		"This URL points to a private network address, which cannot receive webhooks. Use a public URL.",
	webhookUrlPrivate:
		"This URL points to a private network address, which cannot receive webhooks. Use a public URL.",
	webhookUrlInvalid: "This is not a web address. Enter a URL that starts with https://.",
	saveFailed: "Your change was not saved.",
	deleteFailed: "This was not deleted.",
	copyFailed: "Could not copy to the clipboard. Click into the page and try again.",
	fileResetFailed: "The file could not be reset to the original.",
	syncFailed: "The sync could not be started.",
	previewFailed: "The preview could not be loaded.",
	downloadFailed: "The file could not be downloaded.",
	listNotActive: "This list is not active. Activate it to run it.",
	listIsStopping: "This list is still stopping its last run. Try again in a minute.",
	listArchived: "This list is archived. Unarchive it first.",
	listNotIdle: "This list is not waiting for a run, so it cannot be run now.",
	listIdFallback: "List #{{id}}",
	listIsProcessing: "This list is running now. Try again when its run has finished.",
	leadNotExcludable:
		"Only Found or Not found leads in New or Saved for later can be excluded from the list.",
	listSetupScrapeNotRequested:
		"This list still needs its scraping requested. Request it in the list's source step first.",
	listSetupScrapeOngoing: "This list's scraping is still running and has not delivered a file yet.",
	listSetupScrapeUnconfirmed: "Confirm this list's scraped data in its source step first.",
	listSetupSourceMissing: "This list has no source yet. Add a source first.",
	listSetupSourceManualOnly:
		"This list has no uploaded file to run on. Its leads were added manually.",
	listSetupSignalsMissing: "This list is a tracker without signals. Configure its signals first.",
	listSetupFindPersonMissing:
		"This list finds people at their companies. Define its find-person settings first.",
};
